/*============================================================
   REDUX DEPENDENCIES
============================================================*/
import { createSlice } from "@reduxjs/toolkit";

//CREATING A DATA SLICE
const personalInformationSlice = createSlice({
  //REFERENCE NAME OF THIS DATA SLICE
  name: "personalInformation",

  //STATE PROPERTIES INCLUDED IN THIS SLICE
  initialState: {
    first: {
      //Name and Identification
      title: "",
      fullName: "",
      race: "",
      gender: "",
      dob: "",
      age: "",
      countryOfBirth: "",
      countryOfNationality: "",
      maritalStatus: "",
      idType: "",
      idNumber: "",
      isPoliticallyExposed: "",

      //Contact
      mobilecountrycode: "",
      mobilephone: "",
      email: "",
      homecountrycode: "",
      homephone: "",
      officecountrycode: "",
      officephone: "",

      //Residential
      countryofresidence: "",
      postcode: "",
      blockno: "",
      unitno: "",
      streetname: "",
      buildingname: "",
      islanded: "",

      //Employment & Education
      employmentstatus: "",
      employer: "",
      occupation: "",
      highesteducation: "",
      isFinancialBusiness: "",

      //Languages
      spokenEnglish: "",
      spokenMandarin: "",
      spokenMalay: "",
      spokenTamil: "",
      spokenOthers: "",

      writtenEnglish: "",
      writtenMandarin: "",
      writtenMalay: "",
      writtenTamil: "",
      writtenOthers: "",
    },
    second: {
      //Name and Identification
      title: "",
      fullName: "",
      race: "",
      gender: "",
      dob: "",
      age: "",
      countryOfBirth: "",
      countryOfNationality: "",
      maritalStatus: "",
      idType: "",
      idNumber: "",
      isPoliticallyExposed: "",

      //Contact
      mobilecountrycode: "",
      mobilephone: "",
      email: "",
      homecountrycode: "",
      homephone: "",
      officecountrycode: "",
      officephone: "",

      //Residential
      countryofresidence: "",
      postcode: "",
      blockno: "",
      unitno: "",
      streetname: "",
      buildingname: "",
      islanded: "",

      //Employment & Education
      employmentstatus: "",
      employer: "",
      occupation: "",
      highesteducation: "",
      isFinancialBusiness: "",

      //Languages
      spokenEnglish: "",
      spokenMandarin: "",
      spokenMalay: "",
      spokenTamil: "",
      spokenOthers: "",

      writtenEnglish: "",
      writtenMandarin: "",
      writtenMalay: "",
      writtenTamil: "",
      writtenOthers: "",
    },
  },

  //REDUCERS INSIDE EACH SLICE DECLARATION CAN PERFORM ACTION ON EACH DATA STATES
  reducers: {
    updateName: (state, action) => {
      //state.fullName = action.payload;
    },

    updateClientInfo: (state, action) => {
      const actionType = action.payload.type;
      const payload = action.payload.payload;

      switch (actionType) {
        //NAME & IDENTIFICATION
        case "UPDATE_TITLE":
          state[payload.currApplicant].title = payload.data.title;
          break;

        case "UPDATE_FULLNAME":
          state[payload.currApplicant].fullName = payload.data.fullName;
          break;

        case "UPDATE_RACE":
          state[payload.currApplicant].race = payload.data.race;
          break;

        case "UPDATE_GENDER":
          state[payload.currApplicant].gender = payload.data.gender;
          break;

        case "UPDATE_DOB":
          state[payload.currApplicant].dob = payload.data.dob;
          break;

        case "UPDATE_AGE":
          state[payload.currApplicant].age = payload.data.age;
          break;

        case "UPDATE_COUNTRY_OF_BIRTH":
          state[payload.currApplicant].countryOfBirth = payload.data.countryOfBirth;
          break;

        case "UPDATE_COUNTRY_OF_NATIONALITY":
          state[payload.currApplicant].countryOfNationality = payload.data.countryOfNationality;
          break;

        case "UPDATE_MARITAL_STATUS":
          state[payload.currApplicant].maritalStatus = payload.data.maritalStatus;
          break;

        case "UPDATE_ID_TYPE":
          state[payload.currApplicant].idType = payload.data.idType;
          break;

        case "UPDATE_ID_NUMBER":
          state[payload.currApplicant].idNumber = payload.data.idNumber;
          break;

        case "UPDATE_IS_POLITICALLY_EXPOSED":
          state[payload.currApplicant].isPoliticallyExposed = payload.data.isPoliticallyExposed;
          break;

        //CONTACT
        case "UPDATE_COUNTRY_CODE_MOBILE":
          state[payload.currApplicant].mobilecountrycode = payload.data.mobilecountrycode;
          break;

        case "UPDATE_COUNTRY_CODE_HOME":
          state[payload.currApplicant].homecountrycode = payload.data.homecountrycode;
          break;

        case "UPDATE_COUNTRY_CODE_OFFICE":
          state[payload.currApplicant].officecountrycode = payload.data.officecountrycode;
          break;

        case "UPDATE_MOBILE_NUMBER":
          state[payload.currApplicant].mobilephone = payload.data.mobilephone;
          break;

        case "UPDATE_EMAIL":
          state[payload.currApplicant].email = payload.data.email;
          break;

        case "UPDATE_HOME_NUMBER":
          state[payload.currApplicant].homephone = payload.data.homephone;
          break;

        case "UPDATE_OFFICE_NUMBER":
          state[payload.currApplicant].officephone = payload.data.officephone;
          break;

        //RESIDENTIAL
        case "UPDATE_COUNTRY_OF_RESIDENCE":
          state[payload.currApplicant].countryofresidence = payload.data.countryofresidence;
          break;

        case "UPDATE_POSTCODE":
          state[payload.currApplicant].postcode = payload.data.postcode;
          break;

        case "UPDATE_BLOCK_NO":
          state[payload.currApplicant].blockno = payload.data.blockno;
          break;

        case "UPDATE_UNIT_NO":
          state[payload.currApplicant].unitno = payload.data.unitno;
          break;

        case "UPDATE_STREET_NAME":
          state[payload.currApplicant].streetname = payload.data.streetname;
          break;

        case "UPDATE_BUILDING_NAME":
          state[payload.currApplicant].buildingname = payload.data.buildingname;
          break;

        case "UPDATE_IS_LANDED":
          state[payload.currApplicant].islanded = payload.data.islanded;
          break;

        //EMPLOYMENT & EDUCATION
        case "UPDATE_EMPLOYMENT_STATUS":
          state[payload.currApplicant].employmentstatus = payload.data.employmentstatus;
          break;

        case "UPDATE_OCCUPATION":
          state[payload.currApplicant].occupation = payload.data.occupation;
          break;

        case "UPDATE_EMPLOYER":
          state[payload.currApplicant].employer = payload.data.employer;
          break;

        case "UPDATE_HIGHEST_QUALIFICATION":
          state[payload.currApplicant].highesteducation = payload.data.highesteducation;
          break;

        case "UPDATE_IS_FINANCIAL_BUSINESS":
          state[payload.currApplicant].isFinancialBusiness = payload.data.isFinancialBusiness;
          break;

        //LANGUAGES
        case "UPDATE_SPOKEN_ENGLISH":
          state[payload.currApplicant].spokenEnglish = payload.data.spokenEnglish;
          break;

        case "UPDATE_SPOKEN_MANDARIN":
          state[payload.currApplicant].spokenMandarin = payload.data.spokenMandarin;
          break;

        case "UPDATE_SPOKEN_MALAY":
          state[payload.currApplicant].spokenMalay = payload.data.spokenMalay;
          break;

        case "UPDATE_SPOKEN_TAMIL":
          state[payload.currApplicant].spokenTamil = payload.data.spokenTamil;
          break;

        case "UPDATE_SPOKEN_OTHERS":
          state[payload.currApplicant].spokenOthers = payload.data.spokenOthers;
          break;

        case "UPDATE_WRITTEN_ENGLISH":
          state[payload.currApplicant].writtenEnglish = payload.data.writtenEnglish;
          break;

        case "UPDATE_WRITTEN_MANDARIN":
          state[payload.currApplicant].writtenMandarin = payload.data.writtenMandarin;
          break;

        case "UPDATE_WRITTEN_MALAY":
          state[payload.currApplicant].writtenMalay = payload.data.writtenMalay;
          break;

        case "UPDATE_WRITTEN_TAMIL":
          state[payload.currApplicant].writtenTamil = payload.data.writtenTamil;
          break;

        case "UPDATE_WRITTEN_OTHERS":
          state[payload.currApplicant].writtenOthers = payload.data.writtenOthers;
          break;

        default:
          break;
      }
    },
  },
});

//Action creators are generated for each case reducer function
//This declares action that can be acted on this slice of data
export const { updateName, updateClientInfo } = personalInformationSlice.actions;

export default personalInformationSlice.reducer;
